import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import HomeReturnLink from './HomeReturnLink';
import signupApiConfig from '../signup_api_config';

const responsePayload = async response => {
  let payload = await response.json();
  if (typeof payload?.body === 'string') {
    try {
      payload = { ...payload, body: JSON.parse(payload.body) };
    } catch (error) {
      payload = { ...payload, body: { message: payload.body } };
    }
  }
  return payload;
};

const AccountActivationPanel = ({ email, eyebrow, title, subtitle }) => {
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [resendError, setResendError] = useState('');

  const resendVerification = async () => {
    if (!signupApiConfig.cognitoUrl || !email || resending) return;

    setResending(true);
    setResendMessage('');
    setResendError('');
    try {
      const response = await fetch(signupApiConfig.cognitoUrl, {
        method: 'POST',
        body: JSON.stringify({ request_type: 'resendConfirmationCode', username: email })
      });
      const payload = await responsePayload(response);
      const result = payload?.body || payload;
      const statusCode = Number(payload?.statusCode || result?.statusCode || 0);
      if (!response.ok || statusCode >= 400 || String(result?.status || '').toLowerCase() === 'error') {
        throw new Error(result?.message || result?.error || 'We could not resend the verification email. Please try again later.');
      }
      setResendMessage('A new verification email has been requested. Check your inbox and spam folder.');
    } catch (error) {
      setResendError(error.message || 'We could not resend the verification email. Please try again later.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="signup-success-state signup-activation-state">
      <div className="signup-success-mark" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="m5 12.5 4.5 4.5L19 7.5" />
        </svg>
      </div>
      <p className="signup-success-eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p className="signup-success-subtitle">{subtitle}</p>
      <div className="signup-success-email">
        <span className="signup-success-email-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
            <path d="m4.5 7 7.5 6 7.5-6" />
          </svg>
        </span>
        <div>
          <strong>Activate your account</strong>
          <p>We sent a verification email to <b>{email}</b>. Open it to finish setting up your account.</p>
        </div>
      </div>
      {signupApiConfig.cognitoUrl && (
        <div className="signup-activation-resend">
          <Button type="button" variant="outline-primary" onClick={resendVerification} disabled={resending}>
            {resending && <Spinner size="sm" animation="border" className="me-2" aria-hidden="true" />}
            {resending ? 'Sending...' : 'Resend verification email'}
          </Button>
          {resendMessage && <p className="signup-resend-message" role="status">{resendMessage}</p>}
          {resendError && <p className="signup-resend-error" role="alert">{resendError}</p>}
        </div>
      )}
      <div className="signup-success-home-link">
        <HomeReturnLink />
      </div>
    </div>
  );
};

export default AccountActivationPanel;
